/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestTtsAudioCommand } from '../../models/test-tts-audio-command';
import { TestTtsAudioResult } from '../../models/test-tts-audio-result';

export interface ApiModelsTtsTestPost$Params {
      body?: TestTtsAudioCommand
}

export function apiModelsTtsTestPost(http: HttpClient, rootUrl: string, params?: ApiModelsTtsTestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TestTtsAudioResult>> {
  const rb = new RequestBuilder(rootUrl, apiModelsTtsTestPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TestTtsAudioResult>;
    })
  );
}

apiModelsTtsTestPost.PATH = '/api/Models/tts/test';
